/**
 * Constants and the feature flag shared by the browser capture code, the
 * /api/visitor/identify route and the token module. No Node or React imports, so
 * it is safe in the client bundle.
 */

/** Query parameter that carries the email-link token. */
export const VISITOR_TOKEN_PARAM = "aqt";

/** 18-character Salesforce Id (opaque; never an email address). */
export const CONTACT_ID_PATTERN = /^[A-Za-z0-9]{18}$/;

/** "v1." + 18 + "." + up to 8 + "." + 22 = 53 characters; anything longer is not ours. */
export const MAX_TOKEN_LENGTH = 64;

/**
 * NEXT_PUBLIC_VISITOR_TOKEN: on for "1" / "true", off otherwise (the default).
 * Written as a literal property access so Next.js inlines it into client bundles.
 */
export function isVisitorTokenEnabled(): boolean {
    const flag = process.env.NEXT_PUBLIC_VISITOR_TOKEN?.trim().toLowerCase();
    return flag === "1" || flag === "true";
}
